module.exports = __webpack_public_path__ + "static/media/RestaurantHow3.2f936e0a.png";